import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const CardsAsync = lazy(() => import('./ui/Cards'));

export const Cards = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <CardsAsync />
    </Suspense>
  );
};
